export const DIALOG_CONTENT_WIDTH = 400;
export const GRID_SPACING_SM = 3;
export const GRID_SPACING_LG = 4;
export const SCREEN_CONTAINER_WIDTH = 1100;